import { createSlice } from "@reduxjs/toolkit";

const initialState: boolean = false;

export default createSlice({
    name: "isPpc",
    initialState: initialState,
    reducers: {
        set: (state, action) => action.payload,
    },
});
